var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7757 21.7774C64.3811 23.3892 64.4043 26.0262 62.8276 27.6673L34.8164 56.8216C34.0503 57.6189 33.0028 58.0681 31.9095 58.0681C30.8162 58.0681 29.7688 57.6189 29.0027 56.8216L16.2703 43.5696C14.6936 41.9285 14.7168 39.2916 16.3222 37.6798C17.9276 36.068 20.5073 36.0918 22.084 37.7329L31.9095 47.9594L57.0139 21.8305C58.5906 20.1894 61.1703 20.1657 62.7757 21.7774Z",
    fill: "#02A443"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 38.5,
    fill: "#02A443",
    fillOpacity: 0.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.5f96cf0e547f2f87fbda2c333aa16fcc.svg";
export { ForwardRef as ReactComponent };